const styles = {

  gridTimer: {
    mb: 1,
  },
  gridTimerSrp: {
    paddingY: 0.2,
    paddingX: 1.5,

  },
  gridTimerDone: {
    p: 0.2,
    mb: 1,
  },

  timerDone: {
    '&.MuiTypography-body1': {
      textAlign: 'center',
      color: 'common.magenta',
      width: '100%',
    },
  },
  timerSrp: {
    '&.MuiTypography-body1': {
      color: 'white',
    },
  },
  timer: {
    '&.MuiTypography-body1': {
      color: 'common.magenta',
    },
  },

  timerPending: {
    '&.MuiTypography-body1': {
      color: 'text.primary',
    },
  },

}

export default styles
